import {useContext, useState} from 'react';
import ExportExcelUseCase from '../domain/useCase/ExportExcelUseCase';
import ExportPdfUseCase from '../domain/useCase/ExportPdfUseCase';
import {DependencyInjection, DependencyInjectionContext} from '../../../view/context/DependencyInjectionContext';
import {BulletinListFilters} from './useBulletinListFilters';

interface CustomButtonListBulletinResponse {
    handleExportExcel: (bulletinIds: string[], filters: BulletinListFilters) => void;
    handleExportPdf: (bulletinIds: string[], filters: BulletinListFilters) => void;
    loading: boolean;
    error: string;
    clearError: () => void;
}

export const useCustomButtonListBulletinController = (): CustomButtonListBulletinResponse => {
    const dependencyInjectionContext =
        useContext(DependencyInjectionContext) || ({} as DependencyInjection);

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const handleExportExcel = async (bulletinIds: string[], filters: BulletinListFilters) => {
        setLoading(true);
        setError('');
        const exportExcelUseCase = ExportExcelUseCase({
            bulletinRepository: dependencyInjectionContext.bulletinRepository,
            bulletinIds: bulletinIds,
            filters,
        });
        await exportExcelUseCase.then((task: any): void => {
            task
                .onSuccess((response: {data: {url: string}}) => {
                    const link = document.createElement('a');
                    link.href = response.data.url;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .onFail((error: string) => {
                    setError(error || 'Error al exportar Excel');
                })
                .execute();
        }).finally(() => setLoading(false));
    };

    const handleExportPdf = async (bulletinIds: string[], filters: BulletinListFilters) => {
        setLoading(true);
        setError('');
        const exportPdfUseCase = ExportPdfUseCase({
            bulletinRepository: dependencyInjectionContext.bulletinRepository,
            bulletinIds: bulletinIds,
            filters,
        });
        await exportPdfUseCase.then((task: any): void => {
            task
                .onSuccess((response: {data: {url: string}}) => {
                    const link = document.createElement('a');
                    link.href = response.data.url;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .onFail((error: string) => {
                    setError(error || 'Error al exportar PDF');
                })
                .execute();
        }).finally(() => setLoading(false));
    };

    const clearError = () => setError('');

    return {
        handleExportExcel,
        handleExportPdf,
        loading,
        error,
        clearError,
    }
}
